import * as Y from 'yjs'

export class TemplateDoc extends Y.Doc {
    constructor(options?: ConstructorParameters<typeof Y.Doc>[0] & {
        initialValue?: string,
    }) {
        super(options)

        // This is a workaround for document initialization. If each client creates a new Y.Doc and sets the initial value,
        // Yjs will transmit that initial value set to all clients, basically duplicating the initial value on all clients, every
        // time a new client connects. To mitigate this, upon creating a new Y.Doc, we change the clientID to 0, and then set the initial value.
        // This allows us to trick Yjs into thinking that the initial value change all came from the same client, and will thus not re-apply
        // the initial change to all clients.
        if (options?.initialValue) {
            const clientID = this.clientID
            this.clientID = 0
            this.transact(() => this.getText('quill').insert(0, options.initialValue!))
            this.clientID = clientID
        }
    }
}